import { Route, Switch } from "react-router-dom";
import { AppRouteUi } from "../../../config/appRoute";
import { PageNotFound } from "../..";
import { PageTaskListView } from "./pageTaskListView";
import { PageTaskListAdd } from "./pageTaskListAdd";
import { PageTaskListUpdate } from "./pageTaskListUpdate";

export function PageTaskList(): JSX.Element {
  return (
    <div className="">
      <Switch>
        <Route
          path={AppRouteUi.ManageTaskList.Root()}
          exact
          component={PageTaskListView}
        />
        <Route
          path={AppRouteUi.ManageTaskList.Add()}
          exact
          component={PageTaskListAdd}
        />
        <Route
          path={AppRouteUi.ManageTaskList.Update.Root()}
          exact
          component={PageTaskListUpdate}
        />
        <Route path="**" component={PageNotFound} />
      </Switch>
    </div>
  );
}
